import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Config } from '../universal-config';
import {addTags, applyAuth} from './profile.actions';
import {showToast} from "../visual/visual.actions";
import {NIM_AUTH_TYPE} from "../auth-form/auth.model";

@Injectable()
export class ProfileService {

  constructor(
    public _config: Config,
    public _store: Store<any>,
  ) {}

  goToAuth() {
    const loginPath = this._config.get('AUTH_LOGIN_PATH');
    const currentPath = window.location.pathname
    window.location.href = `${ loginPath }&success=${ currentPath }`
  }

  applyAuth(formResult, authType, formPosition) {
    this._store.dispatch(applyAuth(formResult));
    if(authType === NIM_AUTH_TYPE.SIGNUP) {
      const label = `reglabel:${formPosition}`
      this._store.dispatch(addTags([
        "regfsour:shared_note",
        "regfchan:iframe",
        "regfor:personal",
        label
      ]));
    }
  }

  showSignUpSuccessToast() {
    this._store.dispatch(showToast({
      id: 1,
      text: 'Account has been successfully created',
      position: 'right',
    }));
  }

}
